export default "__VITE_ASSET__ByKctoUE__"